import React, { useEffect, useState } from "react";
import Header from "../../components/layout/header";
import LeftMenu from "../../components/layout/leftMenu";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import Schedules from "./Schedules";
import OldSchedules from "./oldSchedules";

export default function SchedulesMain() {
  useEffect(() => {
    setTimeout(() => {
      document.getElementById("ScheduleMenu").classList.add("active");
    }, 500);
  }, []);
  const [menuClick, setMenuClick] = useState(false);

  const toggleMenu = () => {
    setMenuClick(!menuClick);
  };
  const closeMenu = () => {
    setMenuClick(false);
  };

  return (
    <div className="main-wrapper">
      <div className="top-color"></div>
      <LeftMenu menuClick={menuClick} closeMenu={closeMenu} />
      <div className="content-wrapper">
        <Header
          Header="Interview Schedules"
          toggleMenu={toggleMenu}
          menuClick={menuClick}
        />
        <div className="main-container">
          <div className="card main-card">
            <div className="card-body">
              <Tabs
              //   selectedIndex={tabIndex}
              //   onSelect={(index) => {
              //     setTabIndex(index);
              //     console.log("🚀 ~ Newrequirement ~ index:", index);
              //   }}
              >
                <TabList>
                  <Tab>Upcoming Interviews</Tab>
                  <Tab>Past Interviews</Tab>
                </TabList>
                <TabPanel>
                  <Schedules />
                </TabPanel>
                <TabPanel>
                  <OldSchedules />
                </TabPanel>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
